import Vue from 'vue';
import Vuex from 'vuex';
import {auth} from './auth';
import {langues} from './langues';
import {roles} from './roles';
import {category_marchands} from './category_marchands';
import {clientcategory} from './clientcategory';
import {nouveau_marchands} from './nouveau_marchands';
import {state_marchands} from './state_marchands';
import {countries} from './countries';
import {users} from './users';
import {regions} from './regions';
import {cities} from './cities';
import {devises} from './devises';
import {exchanges} from './exchanges';
import {means_paiements} from './means_paiements';
import {documents} from './documents';
import {keys} from './keys';
import {wallets} from './wallets';
import {transfers} from './transfers';
import {marchands} from './marchands';
import {user_means_paiements} from './user_means_paiements';
import {reversements} from './reversements';
import {payments} from "./payments";
import {newsletters} from "./newsletters";
import {settingtransactions} from "./settingtransactions";
import {templates} from "./templates";
import {notifications} from "./notifications";
import {dashboard} from "./dashboard";
import {generalsettings} from "./generalsettings";
import {recharges} from "./recharges";
import {historiqueReversementsConfigs} from "./historiqueReversementsConfigs"
import {intramwallets} from "./intramwallets"
import {webhooks} from "./webhooks"


Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
      auth:auth,
      langues:langues,
      roles:roles,
      category_marchands:category_marchands,
      clientcategory:clientcategory,
      webhooks:webhooks,
      nouveau_marchands:nouveau_marchands,
      state_marchands:state_marchands,
      countries:countries,
      users:users,
      regions:regions,
      documents:documents,
      marchands:marchands,
      transfers:transfers,
      keys:keys,
      wallets:wallets,
      cities:cities,
      devises:devises,
      exchanges:exchanges,
      newsletters:newsletters,
      means_paiements:means_paiements,
      user_means_paiements:user_means_paiements,
      reversements:reversements,
      settingtransactions:settingtransactions,
      templates:templates,
      notifications:notifications,
      payments:payments,
      dashboard:dashboard,
      recharges:recharges,
      historiqueReversementsConfigs:historiqueReversementsConfigs,
      intramwallets:intramwallets,
      generalsettings:generalsettings
  },
    getters: {
        auth() {
            let user = sessionStorage.getItem("user");
            return (user)? JSON.parse(user):undefined;
        },
        isAdmin() {
            let user = sessionStorage.getItem("user");
            return (user)? JSON.parse(user).role._code.includes('admin'):undefined;
        },
        marchand() {
            let user = sessionStorage.getItem("user");
            let isAdmin =  (user)? JSON.parse(user).role._code.includes('admin'):false;
            let marchandCompte = sessionStorage.getItem("marchand");
            if(isAdmin){
                marchandCompte = undefined;
            }else{
                if (marchandCompte!==null && marchandCompte!==undefined && marchandCompte!=='null' && marchandCompte!=='undefined'){
                    marchandCompte = (JSON.parse(marchandCompte)._statut)? JSON.parse(marchandCompte):undefined;
                }else{
                    marchandCompte = undefined;
                }
            }
            return marchandCompte;
        },
        marchandisAllowed() {
            let user = sessionStorage.getItem("user");
            let isAdmin =  (user)? JSON.parse(user).role._code.includes('admin'):false;
            let marchandCompte = sessionStorage.getItem("marchand");
            if(isAdmin){
                marchandCompte = false;
            }else{
                if (marchandCompte!==null && marchandCompte!==undefined && marchandCompte!=='null' && marchandCompte!=='undefined'){
                    marchandCompte = (JSON.parse(marchandCompte)._valide)? true:false;
                }else{
                    marchandCompte = false;
                }
            }
            return marchandCompte;
        },

        keys() {
            let keys = sessionStorage.getItem("keys");
            return (keys)? JSON.parse(keys):undefined;
        },

    }
})
